export enum PollerStatus {
  NOT_STARTED,
  STARTED,
  FINISHED,
}
